import apiClient from "./apiClient";

const apiTokenConsumption = {
  /** Detalhe diário: billing (uuid) ou billing_total (client_id === "all"). */
  get_tokens: (client_id, initial_date, final_date) => {
    return apiClient.get(
      `api/report/consumption/detail/${client_id}/${initial_date}/${final_date}`
    );
  },
  /** Agregação mensal: billing (uuid) ou billing_total (client_id === "all"). */
  get_consumption_by_month: (client_id, initial_date, final_date) => {
    return apiClient.get(
      `api/report/consumption/${client_id}/${initial_date}/${final_date}`
    );
  },
};
export default apiTokenConsumption;
